import React from 'react';

const SuccessIcon = () => (
  <svg
    width={26.67}
    height={26.67}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.666748C6.63996 0.666748 0.666626 6.64008 0.666626 14.0001C0.666626 21.3601 6.63996 27.3334 14 27.3334C21.36 27.3334 27.3333 21.3601 27.3333 14.0001C27.3333 6.64008 21.36 0.666748 14 0.666748ZM11.3333 20.6667L4.66663 14.0001L6.54663 12.1201L11.3333 16.8934L21.4533 6.77341L23.3333 8.66675L11.3333 20.6667Z"
      fill="white"
    />
  </svg>
);

export default SuccessIcon;
